import Vue from 'vue'
import moment from "moment";

export default [
  {
    name: "name",
    title: 'Name',
    width: "60%",
    sortField: "name"
  },
  {
    name: "startDate",
    title: 'Start Date',
    width: "10%",
    sortField: "startDate",
    formatter(value) {
      if (value) {
        let dateStr = moment(new Date(value)).format("YYYY-MM-DD");
        if (dateStr != "0001-01-01") {
          return dateStr;
        } else {
          return "N/A";
        }
      } else {
        return "N/A";
      }
    }
  },
  {
    name: "endDate",
    title: 'End Date',
    width: "10%",
    sortField: "name",
    formatter(value) {
      if (value) {
        let dateStr = moment(new Date(value)).format("YYYY-MM-DD");
        if (dateStr != "0001-01-01") {
          return dateStr;
        } else {
          return "N/A";
        }
      } else {
        return "N/A";
      }
    }
  },

]